import _Chip from "@material-ui/core/esm/Chip";
import React from 'react';
import { VARIANT_COLORS } from 'swag-client-common/constants';
import closeIcon from './active-filter-item-other';
import CSSclasses from './active-filter-item.scss';
const styles = {
  root: CSSclasses.chipRoot,
  deleteIcon: CSSclasses.deleteIcon,
  label: CSSclasses.label
};
const getColorItem = color => /*#__PURE__*/React.createElement("span", {
  className: CSSclasses.colorItem,
  style: {
    backgroundColor: color
  }
});
const ActiveFilterItem = ({
  itemName,
  onRequestDelete
}) => {
  const hexColor = VARIANT_COLORS[itemName];
  return /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.chip,
    "data-label": itemName
  }, /*#__PURE__*/React.createElement(_Chip, {
    deleteIcon: /*#__PURE__*/React.createElement("img", {
      src: closeIcon
    }),
    classes: styles,
    onDelete: onRequestDelete,
    label: hexColor ? getColorItem(hexColor) : itemName
  }));
};
export default ActiveFilterItem;